(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[472,9600],{

/***/ 2248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ security; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-lg@2x.png
var Hero_lg_2x = __webpack_require__(49946);
var Hero_lg_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_lg_2x);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-lg.webp
var Hero_lg = __webpack_require__(53965);
var Hero_lg_default = /*#__PURE__*/__webpack_require__.n(Hero_lg);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-lg@2x.webp
var assets_Hero_lg_2x = __webpack_require__(20999);
var assets_Hero_lg_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_lg_2x);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-lg@3x.webp
var Hero_lg_3x = __webpack_require__(17595);
var Hero_lg_3x_default = /*#__PURE__*/__webpack_require__.n(Hero_lg_3x);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-xs@2x.png
var Hero_xs_2x = __webpack_require__(56383);
var Hero_xs_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_xs_2x);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-xs.webp
var Hero_xs = __webpack_require__(28657);
var Hero_xs_default = /*#__PURE__*/__webpack_require__.n(Hero_xs);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-xs@2x.webp
var assets_Hero_xs_2x = __webpack_require__(31814);
var assets_Hero_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_xs_2x);
// EXTERNAL MODULE: ./src/views/Security/components/Hero/assets/Hero-xs@3x.webp
var Hero_xs_3x = __webpack_require__(25510);
var Hero_xs_3x_default = /*#__PURE__*/__webpack_require__.n(Hero_xs_3x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Security/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var copy = {
  overline: "Segment\u2019s Stance on Security ",
  heading: "Secure and private by default",
  description: "We take the responsibility of helping you manage your customer data seriously. That\u2019s why security and privacy are key focus areas for our organization and product development."
};

var Hero = function Hero() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var desktopResolutionMediaQuery = theme.breakpoints.up("lg", false);
  var isDesktop = (0,useMatchMedia/* default */.Z)(desktopResolutionMediaQuery, true);
  var _webp$webp2$webp3$png = {
    webp: (Hero_xs_default()),
    webp2: (assets_Hero_xs_2x_default()),
    webp3: (Hero_xs_3x_default()),
    png2: (Hero_xs_2x_default()),
    size: [312, 469]
  },
      webp = _webp$webp2$webp3$png.webp,
      webp2 = _webp$webp2$webp3$png.webp2,
      webp3 = _webp$webp2$webp3$png.webp3,
      png2 = _webp$webp2$webp3$png.png2,
      size = _webp$webp2$webp3$png.size;

  if (isDesktop) {
    webp = (Hero_lg_default());
    webp2 = (assets_Hero_lg_2x_default());
    webp3 = (Hero_lg_3x_default());
    png2 = (Hero_lg_2x_default());
    size = [606, 402];
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroRecipeCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          variant: "h5",
          tag: "h5",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "h2",
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat(webp, ", ").concat(webp2, " 2x, ").concat(webp3, " 3x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: size[0],
            height: size[1],
            src: png2,
            alt: "Hero",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e16bl41h2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e16bl41h1"
} : 0)(recipes_Hero/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{text-align:left;}}" + ( true ? "" : 0));

var HeroRecipeCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e16bl41h0"
} : 0)( true ? {
  name: "xyzkeb",
  styles: "align-self:flex-start"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var components_Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ./src/views/Security/components/InternalSecurity/assets/InternalSecurity@2x.png
var InternalSecurity_2x = __webpack_require__(25484);
var InternalSecurity_2x_default = /*#__PURE__*/__webpack_require__.n(InternalSecurity_2x);
// EXTERNAL MODULE: ./src/views/Security/components/InternalSecurity/assets/InternalSecurity.webp
var assets_InternalSecurity = __webpack_require__(7085);
var InternalSecurity_default = /*#__PURE__*/__webpack_require__.n(assets_InternalSecurity);
// EXTERNAL MODULE: ./src/views/Security/components/InternalSecurity/assets/InternalSecurity@2x.webp
var assets_InternalSecurity_2x = __webpack_require__(95084);
var assets_InternalSecurity_2x_default = /*#__PURE__*/__webpack_require__.n(assets_InternalSecurity_2x);
// EXTERNAL MODULE: ./src/views/Security/components/InternalSecurity/assets/InternalSecurity@3x.webp
var InternalSecurity_3x = __webpack_require__(97710);
var InternalSecurity_3x_default = /*#__PURE__*/__webpack_require__.n(InternalSecurity_3x);
;// CONCATENATED MODULE: ./src/views/Security/components/InternalSecurity/InternalSecurity.tsx



function InternalSecurity_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var InternalSecurity_copy = {
  heading: "Internal Security"
};
var feature1 = {
  heading: "Data encryption",
  description: {
    content: [{
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "Your data is encrypted at rest and protected by TLS in transit. Your Segment password is hashed using bcrypt, and we manage our production "
      }, {
        content: [{
          data: {},
          marks: [],
          nodeType: "text",
          value: "secrets"
        }],
        data: {
          uri: "/blog/the-right-way-to-manage-secrets/"
        },
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        nodeType: "text",
        value: " with AWS tools."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
};
var feature2 = {
  heading: "Rigorous product design and security testing",
  description: "Our projects pass thorough security-design reviews, threat models, and regular pen tests using trusted security vendors. We also employ a public bug bounty for continuous assessment."
};
var feature3 = {
  heading: "Time-bound access",
  description: ["We systematically limit internal access to critical tools and resources using time-based access.", "For more details on security at Segment, download our Security Overview."],
  link: {
    text: "Security at Segment",
    url: "https://security.segment.com"
  }
};
var options = {
  renderNode: (0,defineProperty/* default */.Z)({}, dist.BLOCKS.PARAGRAPH, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, {
      tag: "span",
      variant: "pMedium",
      children: children
    });
  })
};

var InternalSecurity = function InternalSecurity() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    copyVariant: "narrow",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          children: InternalSecurity_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBoxList, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
          alignment: "left",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
              children: feature1.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                data: feature1.description,
                options: options
              })
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
          alignment: "left",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
              children: feature2.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
              children: feature2.description
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
          alignment: "left",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
              children: feature3.heading
            }), feature3.description.map(function (paragraph, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                children: paragraph
              }, index);
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
              href: feature3.link.url,
              size: "small",
              target: "_blank",
              children: feature3.link.text
            })]
          })
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPicture, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((InternalSecurity_default()), ", ").concat((assets_InternalSecurity_2x_default()), " 2x, ").concat((InternalSecurity_3x_default()), " 3x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
          width: "521",
          height: "482",
          src: (InternalSecurity_2x_default()),
          alt: "Internal Security",
          loading: "lazy"
        })]
      })
    })]
  });
};

var FeatureBoxList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ergwuap3"
} : 0)( true ? {
  name: "1gs8xtw",
  styles: "display:grid;gap:24px;grid-auto-flow:row;margin-top:56px;padding:0"
} : 0);

var SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ergwuap2"
} : 0)( true ? {
  name: "1jxwh0y",
  styles: "justify-content:center;align-self:center;display:flex;overflow:hidden;picture>img{object-fit:contain;}"
} : 0);

var StyledText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ergwuap1"
} : 0)("color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.brand.darkAcai[500];
}, ";margin:0;" + ( true ? "" : 0));

var StyledPicture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ergwuap0"
} : 0)( true ? "" : 0);

/* harmony default export */ var InternalSecurity_InternalSecurity = (InternalSecurity);
// EXTERNAL MODULE: ../../libs/templates/Testimonial/index.ts + 2 modules
var Testimonial = __webpack_require__(5099);
;// CONCATENATED MODULE: ./src/views/Security/components/Testimonial/Testimonial.tsx


function Testimonial_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Testimonial_copy = {
  text: "\u201CAny experienced security practitioner can tell you that technology and processes are just two key components of an effective security program. People are the third component. At Segment, security is everyone\u2019s responsibility.\u201D",
  name: "Coleen Coolidge",
  position: "CISO at Twilio Segment"
};

var TestimonialBox = function TestimonialBox() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* default */.Z, {
        text: Testimonial_copy.text,
        name: Testimonial_copy.name,
        position: Testimonial_copy.position
      })
    })
  });
};

var Testimonial_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fkjszu1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1fkjszu0"
} : 0)( true ? {
  name: "z23a2x",
  styles: "max-width:1060px"
} : 0);

/* harmony default export */ var Testimonial_Testimonial = (TestimonialBox);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
;// CONCATENATED MODULE: ./src/views/Security/components/ProductSecurity/ProductSecurity.tsx







var ProductSecurity_copy = {
  heading: "Product Security"
};
var columnTrackData = [{
  heading: "Manage access to your account",
  description: "Centrally manage your policies for access with Single Sign-On (SSO) on the Business plan."
}, {
  heading: "Control visibility with user access levels",
  description: "Control access to your Sources and Workspaces with fine-grained permissions to manage how your users interact with your data."
}, {
  heading: "System for Cross-domain Identity Management (SCIM)",
  description: "SCIM allows your Identity Provider (IdP) to manage users and group membership within the Segment application."
}, {
  heading: "Password guidance",
  description: "When choosing a new password, we provide visual guidance to help customers pick strong passwords that have not been exposed in security breaches on other websites."
}, {
  heading: "Multi-factor authentication (MFA)",
  description: "MFA provides an additional layer of security beyond your username and password. When logging into Segment, you\u2019ll also enter a code from your mobile phone."
}];

var ProductSecurity = function ProductSecurity() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyleSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          variant: "h2",
          children: ProductSecurity_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        columns: 1,
        overrides: {
          lg: 3
        },
        center: false,
        children: columnTrackData.map(function (_ref) {
          var heading = _ref.heading,
              description = _ref.description;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
            alignment: "left",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                children: heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                children: description
              })]
            })
          }, heading);
        })
      })
    })]
  });
};

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "eb3w6ll3"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{text-align:center;}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "eb3w6ll2"
} : 0)("align-items:flex-start;row-gap:40px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:60px;}" + ( true ? "" : 0));

var StyleSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eb3w6ll1"
} : 0)(Section/* Wrapper */.im, "{justify-items:flex-start;row-gap:60px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("md");
}, "{max-width:720px;padding:120px 0;margin:auto;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:max-content;padding:80px 80px 120px;justify-items:center;}}" + ( true ? "" : 0));

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "eb3w6ll0"
} : 0)(function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.down("md");
}, "{width:100%;}", Section/* Wrapper */.im, "{margin:0 auto;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("lg");
}, "{margin:0;}}" + ( true ? "" : 0));

/* harmony default export */ var ProductSecurity_ProductSecurity = (ProductSecurity);
;// CONCATENATED MODULE: ./src/views/Security/components/BugBountyProgram/assets/BugBounty@2x.png
/* harmony default export */ var BugBounty_2x = ("data:image/png;base64,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");
;// CONCATENATED MODULE: ./src/views/Security/components/BugBountyProgram/assets/BugBounty.webp
/* harmony default export */ var BugBounty = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Security/components/BugBountyProgram/assets/BugBounty@2x.webp
/* harmony default export */ var assets_BugBounty_2x = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Security/components/BugBountyProgram/assets/BugBounty@3x.webp
/* harmony default export */ var BugBounty_3x = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Security/components/BugBountyProgram/BugBountyProgram.tsx


function BugBountyProgram_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var BugBountyProgram_copy = {
  heading: "Bug bounty program",
  description: "Happy Hunting!"
};
var richTextDescription = {
  content: [{
    content: [{
      data: {},
      marks: [],
      nodeType: "text",
      value: "Since August of 2017, Segment has run a bug bounty program on the Bugcrowd platform. This program has provided tremendous value, and has improved security for both Segment and our customers. We consider our bug bounty program one of the best investments for finding and fixing existing vulnerabilities in our applications and internet-facing assets. We\u2019ve also built productive relationships with security researchers and see some as an extension of our team. If you\u2019ve found a vulnerability, please "
    }, {
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "read the rules of our bounty brief and submit here"
      }],
      data: {
        uri: "https://bugcrowd.com/twilio",
        target: "_blank"
      },
      nodeType: dist.INLINES.HYPERLINK
    }, {
      data: {},
      marks: [],
      nodeType: "text",
      value: "."
    }],
    data: {},
    nodeType: dist.BLOCKS.PARAGRAPH
  }],
  data: {},
  nodeType: dist.BLOCKS.DOCUMENT
};

var BugBountyProgram = function BugBountyProgram() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BugBountyProgram_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: BugBountyProgram_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
              data: richTextDescription
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: BugBountyProgram_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BugBountyProgram_SectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat(BugBounty, ", ").concat(assets_BugBounty_2x, " 2x, ").concat(BugBounty_3x, " 3x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
            width: "192",
            height: "36",
            src: BugBounty_2x,
            alt: "Internal Security",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var BugBountyProgram_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1iuxfmm1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var BugBountyProgram_SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1iuxfmm0"
} : 0)( true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0);

/* harmony default export */ var BugBountyProgram_BugBountyProgram = (BugBountyProgram);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ./src/views/Security/components/Certifications/assets/Iso27001@2x.png
var Iso27001_2x = __webpack_require__(91481);
var Iso27001_2x_default = /*#__PURE__*/__webpack_require__.n(Iso27001_2x);
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/assets/Iso27001.webp
/* harmony default export */ var Iso27001 = ("data:image/webp;base64,UklGRiYLAABXRUJQVlA4WAoAAAAQAAAAdwAAiwAAQUxQSFwGAAAB8FZte9Zs27YtEiJhlYCESMDBHgc7DhoHxUHqgNNBJCBhlRAJ8w8gUOh5ntf3FREToAeGcSqLO0DzWt9TDPr9IRXnyvUdf1qYKr11Th8/AFoZf1UsDaAt0/CGNmqbocWYK1t/2w+KFaDNUdJfcNP+BM2kkBa2xX5MrAA1amsNNx1PULW15ADFfkh4A5SofYek3hnyRlJywNPPiA5U02GCou7gNNuTkgPVfsMb8Khjc9z6FKEcSbmBpx9gKzAHdb4g6WyF2CGrwOtxgwPraD2O63SE0hNGB2p41tjYb/U9xiApQTqnCmFjKS/OvtuT/gDzZ+W41cUhRbMus+EFtVTnuBUHt+f8AbKkMM61bc42dy5s65xMCiu4PWUAso5DnOa69p32WqbRdPwBD88wh6zTjscx5TyX4znnlBLMOr1CfURwyDo9wKxrnXYurPB+QoFF5zPEizIMp2QOf+73FzxcUHFdHGE6pwGa3c0azXQ+QLlKjXqBJqh3+0/AYBbjYOEOwYYYLXxryJd3hfReG8dtre98mE6F+K6N/baWZF9IXN4xVr5YT8TSOF3TY6Lz1b5YudbTM958uevN9cUeULiNrXzTh9u9uI05323DzYzbBOfbze5VTjX3dlHh+x5uRX+JQdth/PipxFlfyrKeIZ8afdv6fFeKfZO68xk/UaO2Np/AzuzHLtdh6lN/OpHozzoeWt98o9wX+sZ6+N7UvqLeqa+Fh6zWddLoty7VLtJ9pj5YphiuSX1F/VNfuc94ZtvW+p7G4cTSN54IfX6fcMVhq3noWPvCCXkX4Taq1209HbSuprNL33Cf+B1w26HbT3364n1UvwR/JFlfPTX3pRuZf4v4tfwU2fotDwp9furTF+8kZf8Ok/Sd5UEKqX6lSt7FqdpnN5Nk41zbVQQtfcOZ1qf77YZhnOa6nhs0900nIt31KYeW/ERU7KsnSt98nxCPuyTVM6F1EbuM/uE+kUM/k85o7nPrWfpcJ0PcTn1x9xulL0jWh9tBqPSnM4nLuyix6y/dLklzH5RxMBvfjX7XI6DVd04ppVwa/WUT2omL41Out43iDbJ+TNF+/tpHP8bDgfKXPvoxbupM7RtZP2YO6rbPZR71W2rU6VgvWZMufkirOehSm9cTPkddHuxydQ8xTbmUWutSSk5D0BdDnOZSay1lGk3/GWkpjVeElIbLxhSvsJTS3YLDdIEa9aoA/7iiQL6bhkazCxZauGiEdMELXPefwO3cBPGiAnZuhGYP0AxrOBWgXORUnbYGSU8MK6zhhEWnlaW6O4fua61lgbedMYesZwaHNewN6b04X1/rexwOzCHrqeawWhjftdHtXutSDpdaVz/Yr+/RNDT46Lnm0Dhsa8lprDDofIKccqlts10bfPRkW9n6Mo2m3QjzBY5rN8RpWdnNenZYgKLuSrNTCfLebmzApMdnwK0nQjnluPX8beBRPzA6UOxIFeKJF2QdxwpU00+0D+AvO4iw9hm4Dq0AbdLPHBzwl+1ohndPcIh7sQAspl+aHKDETXCYOhbIkhSmClCjfm1yAC9RsgavvVBglUKqDaBG/eJxYbe+X0AxSdGhzcXZtjnqV1uq9K610dlKDPrpYZxr2+v0ZYr65zjElOeynXMagv5/yqP7LMlqg/XvXlwaeLGOoTaoUVr8MEv2brCmvaE2qGnHqrt9L0GRrLFbNi8O/xwMjd2oyuEga+yWzR/2X5L+NuA2FUYbVojSC1oexw8Q91bIQ4aqlHPOBVxymGN0yJI1yDE5RI1sbwNVUqx1lAEmSRl8x6BIctBugqQERZI1mlRgkhShKrWp3qjRovYzFO02iDs5R0ntaAXTAlGSFhi0gkmSQ4imO1Wg1fcoqcK494Fps5+g7gxQpQq2mSEJmrYVBulW5uy6bWJH7jAH2ymQJD/Ie77zgXgzKeZlBWYtkPYWmI7CClm7TgvSeqbtVBhutx3ANcO85xAPwgpZuyMUSQvEzQJRDmGzQrjXCLMkNVZFaLb5C67DAln7C0RJE2RJwWnSDJMkg1X3Co02SC8o0gc8DfYC0kGBJcYYg2TgkhQaTGYLzFKEliyukG6mCWgN3KSwcpi1/+LQpARlo8T+GiRl9j+6m5IDVNM2+aZG7U90rWA7ihVoOWibHGiTbtQZBgs6DtGCbhiiqTNE0/9ICVZQOCCkBAAA8BcAnQEqeACMAD4xFoZCoiGMxgpGEAGCWNu3+WLwB+gH8AnwVF870HtvlDvWDFz2Lx77ZX9r9RX6W9gD9U+k15jP2V/Zn3rPRT/nPUA/sf9g6w70APLq9k3/Af930y/UA///BLdAPwA/QD8l+/w4NFP3jdlAvC0OIlTUDnHjx7DSqJQQ+601dem8rugQ4nOYyN0iXu5C9TVgZIvBl3VManTMbVLVAnIHKcmQ/D1ZbJsAqnIDJeXgcOFhtSji2I5bI/XL6iPR+gAA/v6lQ2cWM4XXGLDt9bLVXihEyEd9YZI73APLefxmCvFig6PtGy37iBVIWVxi4w5g8gOeeR0+lSZPU3zqR2ODm15t+a5N6umD0yiGw/w3erEP4tOCL6qaUrk/FHg3w/JaoIs0x4OHYpXskZjx9zobmrpOx//3v9/++P3//ezQgIadKVaxTlsTZiJhF1DuymNeNsONf+S295Pv//oGOw2W93r+OQ+7OIqmYELnsYXHpbnN9S3TpFoAyPjemRDv6W+CP+wV//3v9/++P3//ezRr811b1sOdnRju/yJUI8Xlx5UNlJY0z7KWpCxw+7fJy9GI/g5yUeQ7y0GlQ3Gr+gWlEkxICc50LaGUxEss9ik6aCUwO5EM63tYj4T9SWrvGd47f8f8EuUQ3FczqCV5htEm0+MJbdDig50j7sjYSAJx3n3JeuCCsvH9nzN+aUx5gYRHytw+klGaGnRzPnlOJAIvAn6Oyo+6AgvnrZ7Uxq4Q46ESV6AqX8pCN54wFvOIovOGrrqhga7qExUzDh5TIajMSHFaCLvdm/YsKLRXKg+D/q6EZSsKX/OpywaAE1DrAAhuSJRkTzxM8wZk9y5z9Pfiew1Xfl6lv8O9ekhgnO3WHoS+rf63N4kzJsvTpJn/5THs5Hwc1NRP/JHZsdLJZkgV8APhYBvrFGyLb0my7rns2+8ovkBP4YSA84vwifgnL9xhdUDnbUR4hV5agn6Ry4bOPDWSplKT8yTqIpE8hFsnOHbh35RQ7QKcSQLPAmtc9cPynNYdg3Fp1HN3eqpUjZI+gSSzmE1SKXEDJs7Jf53bsIPYOoF63q8aaXymqYkxZ+NwPGBzbHQiSnUAoF26JlkVcnv3ilCsp4b0BA+U/R6TlrUaD9FrMNscEI613ZxBk+a4MIhtteDfS3FFCiePJl6QDwxWmKqoNP/FP1m3ub0ADiMjiAGX///zL5V+0U1SR56AJoKDG9n8eUmn2ua4QdJm24ZR7pth/wI+BGd/zDAkb1GCTzTGlX7EAAAAADdwsF/onOX3c4r7oTIx63GmqKHH58KozzOAA9mPVGwXZDRSl56eOxNV1HlNHDz+zxWUTdh/Qsy26cbEphaAAGvtgoFXZ+nI1XarDiFJ2/d614uq/xd+JY4U6MFCe/UHlKMkKkqxDRThCDzr2IS9gC9RJKFMYWY1xyo4Yz9VSwhUCjz///NZiseuwguKWMe27hgrRRr//M4pQp2XiURDlID6k0nXCTzpU12WVgu8RVs7JUC8lnvlWQr81DQwXRWHVkFU2d3tQJNBqZdv2xXY3vzPHcdnuM2MXdF34QtkAAAA");
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/assets/Iso27001@2x.webp
/* harmony default export */ var assets_Iso27001_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Security/components/Certifications/assets/Iso27017@2x.png
var Iso27017_2x = __webpack_require__(80548);
var Iso27017_2x_default = /*#__PURE__*/__webpack_require__.n(Iso27017_2x);
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/assets/Iso27017.webp
/* harmony default export */ var Iso27017 = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/assets/Iso27017@2x.webp
/* harmony default export */ var assets_Iso27017_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Security/components/Certifications/assets/Iso27018@2x.png
var Iso27018_2x = __webpack_require__(51723);
var Iso27018_2x_default = /*#__PURE__*/__webpack_require__.n(Iso27018_2x);
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/assets/Iso27018.webp
/* harmony default export */ var Iso27018 = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/assets/Iso27018@2x.webp
/* harmony default export */ var assets_Iso27018_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/Security/components/Certifications/assets/AicpaSocBadge@2x.png
var AicpaSocBadge_2x = __webpack_require__(34717);
var AicpaSocBadge_2x_default = /*#__PURE__*/__webpack_require__.n(AicpaSocBadge_2x);
// EXTERNAL MODULE: ./src/views/Security/components/Certifications/assets/AicpaSocBadge.webp
var AicpaSocBadge = __webpack_require__(14941);
var AicpaSocBadge_default = /*#__PURE__*/__webpack_require__.n(AicpaSocBadge);
// EXTERNAL MODULE: ./src/views/Security/components/Certifications/assets/AicpaSocBadge@2x.webp
var assets_AicpaSocBadge_2x = __webpack_require__(91083);
var assets_AicpaSocBadge_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AicpaSocBadge_2x);
;// CONCATENATED MODULE: ./src/views/Security/components/Certifications/Certifications.tsx



function Certifications_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var Certifications_copy = {
  heading: "Certifications and attestations",
  description: "Segment\u2019s security and privacy program is based on and aligned with industry-standard frameworks, and we maintain a comprehensive suite of certifications and attestations to further demonstrate our commitment to security and privacy."
};
var Certifications_link = {
  text: "View documentation",
  url: "https://security.segment.com \n  "
};

var Certifications = function Certifications() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Certifications_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FirstSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: Certifications_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: Certifications_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: Certifications_link.url,
            target: "_blank",
            children: Certifications_link.text
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SecondSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Certifications_StyledColumnTrack, {
          columns: 1,
          overrides: {
            lg: 4
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "ISO 27001",
            images: {
              webp: Iso27001,
              webp2x: assets_Iso27001_2x,
              png2x: (Iso27001_2x_default())
            },
            size: [120, 140]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "ISO 27017",
            images: {
              webp: Iso27017,
              webp2x: assets_Iso27017_2x,
              png2x: (Iso27017_2x_default())
            },
            size: [116, 140]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "ISO 27018",
            images: {
              webp: Iso27018,
              webp2x: assets_Iso27018_2x,
              png2x: (Iso27018_2x_default())
            },
            size: [119, 140]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
            alt: "SOC 2 Type 2",
            images: {
              webp: (AicpaSocBadge_default()),
              webp2x: (assets_AicpaSocBadge_2x_default()),
              png2x: (AicpaSocBadge_2x_default())
            },
            size: [96, 96]
          })]
        })
      })
    })]
  });
};

var Image = function Image(_ref) {
  var images = _ref.images,
      alt = _ref.alt,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? [179, 120] : _ref$size;

  var _size = (0,slicedToArray/* default */.Z)(size, 2),
      w = _size[0],
      h = _size[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat(images.webp, ", ").concat(images.webp2x, " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
        width: w,
        height: h,
        src: images.png2x,
        alt: alt,
        loading: "lazy"
      })]
    })
  });
};

var Certifications_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e8fcy524"
} : 0)( true ? {
  name: "14fwa3k",
  styles: "max-width:690px;margin:0 auto"
} : 0);

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8fcy523"
} : 0)( true ? {
  name: "i38kcj",
  styles: "display:flex;align-items:center;flex-direction:column"
} : 0);

var Certifications_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8fcy522"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{max-width:720px;margin:auto;}" + ( true ? "" : 0));

var FirstSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e8fcy521"
} : 0)(Section/* Wrapper */.im, "{row-gap:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:60px;}}" + ( true ? "" : 0));

var SecondSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e8fcy520"
} : 0)(Section/* Wrapper */.im, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:0;}}" + ( true ? "" : 0));

/* harmony default export */ var Certifications_Certifications = (Certifications);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Security/components/Articles/Articles.tsx


function Articles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var data = [{
  heading: "How Twilio Segment proactively protects customer\u2019s API tokens",
  author: "Sal Olivares, Senior Software Engineer, Security",
  link: "/blog/how-segment-proactively-protects-customer-api-tokens/"
}, {
  heading: "Changing of the guard: migrating an authorization service used by thousands of customers from Go to Typescript",
  author: "Rex Chen, Staff Software Engineer, Security",
  link: "/blog/migrate-from-go-to-typescript/"
}, {
  heading: "Tracking Meaningful Security Product Metrics",
  author: "Leif Dreizler, Senior Engineering Manager, Security",
  link: "/blog/track-meaningful-security-product-metrics/"
}, {
  heading: "How to plan an SMS MFA migration that affects thousands of users",
  author: "Jordan Kohl, Staff Software Engineer, Security",
  link: "/blog/plan-sms-mfa-migration-for-thousands-users/"
}, {
  heading: "Redefining Threat Modeling: Security team goes on vacation",
  author: "Jeevan Singh, Director of Product Security",
  link: "/blog/redefining-threat-modeling/"
}, {
  heading: "Access Service: Temporary Access to the Cloud",
  author: "Andy Li, Software Engineer, Security",
  link: "/blog/access-service/"
}, {
  heading: "Shifting Engineering Right: What security engineers can learn from DevSecOps",
  author: "Leif Dreizler, Senior Engineering Manager, Security",
  link: "/blog/shifting-engineering-right/"
}, {
  heading: "How we approach security",
  author: "Coleen Coolidge, CISO at Twilio Segment",
  link: "/blog/how-we-approach-security/"
}, {
  heading: "Scaling security services with AWS organizations",
  author: "Pablo Vidal Bouza, Cloud Security Engineer",
  link: "/blog/segment-aws-organizations/"
}];
var Articles_copy = {
  heading: "Articles by Security"
};

var Articles = function Articles() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var desktopResolutionMediaQuery = theme.breakpoints.up("lg", false);
  var twoColumnMediaQuery = theme.breakpoints.down("lg", false);
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(desktopResolutionMediaQuery, true);
  var isTwoColumnResolution = (0,useMatchMedia/* default */.Z)(twoColumnMediaQuery, false);

  var _useState = (0,react.useState)(9),
      limit = _useState[0],
      setLimit = _useState[1];

  (0,react.useEffect)(function () {
    setLimit(isDesktopResolution ? 9 : 3);
  }, [isDesktopResolution, isTwoColumnResolution]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Articles_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Articles_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: Articles_copy.heading
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 2,
            xl: 3
          },
          children: data.slice(0, limit).map(function (data, index) {
            return data.heading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              href: (0,getAbsoluteUrl/* default */.Z)(data.link || "", pageConfig),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    children: data.heading
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                    variant: "pMedium",
                    children: data.author
                  })]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "right",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                })]
              })
            }, index) : isDesktopResolution && !isTwoColumnResolution && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {}, index);
          })
        })
      }), limit <= data.length && limit !== data.length && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
        onClick: function onClick() {
          return setLimit(data.length);
        },
        iconEnd: Common/* ChevronRightIcon */.XC,
        children: "Show all"
      })]
    })
  });
};

var Articles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecqsxsm2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var Articles_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ecqsxsm1"
} : 0)(Section/* Wrapper */.im, "{row-gap:60px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:80px;}}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "ecqsxsm0"
} : 0)( true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0);

/* harmony default export */ var Articles_Articles = (Articles);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
;// CONCATENATED MODULE: ./src/views/Security/components/CommitmentToDataPrivacy/CommitmentToDataPrivacy.tsx


function CommitmentToDataPrivacy_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var CommitmentToDataPrivacy_copy = {
  heading: "Segment\u2019s commitment to data privacy",
  description: "We take the responsibility of respecting privacy seriously. Here are a few initiatives Segment is committed to:"
};

var CommitmentToDataPrivacy = function CommitmentToDataPrivacy() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var columnTrackData = (0,react.useMemo)(function () {
    return [{
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DataIcon */.d1, {
        color: theme.palette.twilio.gray[100]
      }),
      heading: "Data Processing Agreement",
      description: "Our Data Processing Agreement (DPA) reflects the requirements of the GDPR."
    }, {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* BusinessIcon */.wZ, {
        color: theme.palette.twilio.gray[100]
      }),
      heading: "Data Transfer Practices",
      description: "We offer Standard Contractual Clauses for compliant user data transfer and storage outside of the EU."
    }, {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* SafeIcon */.zQ, {
        color: theme.palette.twilio.gray[100]
      }),
      heading: "Privacy by Design",
      description: "Your data is yours to own. Segment does not sell our customers' user data."
    }, {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* ReportIcon */.cW, {
        color: theme.palette.twilio.gray[100]
      }),
      heading: "Privacy Policy",
      description: "Our Privacy Policy honors CCPA, the GDPR, the Privacy Shield Framework."
    }, {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CompliantIcon */.Kg, {
        color: theme.palette.twilio.gray[100]
      }),
      heading: "Data Protection Officer",
      description: "Segment has appointed a Data Protection Officer to oversee our ongoing compliance efforts."
    }];
  }, [theme]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommitmentToDataPrivacy_Wrapper, {
    id: "commitment-to-data-privacy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommitmentToDataPrivacy_SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: CommitmentToDataPrivacy_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: CommitmentToDataPrivacy_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommitmentToDataPrivacy_StyledColumnTrack, {
          columns: 1,
          overrides: {
            lg: 3
          },
          center: false,
          children: columnTrackData.map(function (_ref) {
            var heading = _ref.heading,
                description = _ref.description,
                icon = _ref.icon;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
              alignment: "left",
              headerPosition: "top",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                  elevation: 1,
                  variant: "circle",
                  children: icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: description
                })]
              })]
            }, heading);
          })
        })
      })]
    })
  });
};

var CommitmentToDataPrivacy_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epbunym2"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var CommitmentToDataPrivacy_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "epbunym1"
} : 0)("align-items:flex-start;row-gap:60px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:80px;}" + ( true ? "" : 0));

var CommitmentToDataPrivacy_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "epbunym0"
} : 0)( true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0);

/* harmony default export */ var CommitmentToDataPrivacy_CommitmentToDataPrivacy = (CommitmentToDataPrivacy);
// EXTERNAL MODULE: ./src/views/Security/assets/OgSecurity.png
var OgSecurity = __webpack_require__(17731);
var OgSecurity_default = /*#__PURE__*/__webpack_require__.n(OgSecurity);
;// CONCATENATED MODULE: ./src/views/Security/Security.tsx


















var Security = function Security() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Security | Twilio Segment",
      pageDescription: "We take the responsibility of helping you manage your customer data seriously.",
      pageOG: (OgSecurity_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InternalSecurity_InternalSecurity, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductSecurity_ProductSecurity, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BugBountyProgram_BugBountyProgram, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Certifications_Certifications, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommitmentToDataPrivacy_CommitmentToDataPrivacy, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Articles_Articles, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrapperLogoTiles, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var WrapperLogoTiles = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pxomfd1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1pxomfd0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Security_Security = (Security);
;// CONCATENATED MODULE: ./src/pages/security.tsx



var security_Security = function Security() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Security_Security, {});
};

/* harmony default export */ var security = (security_Security);

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Testimonial_Testimonial; }
});

// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 229 modules
var CompanyMono = __webpack_require__(71385);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 237 modules
var Company = __webpack_require__(97079);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/data.tsx





var data = [{
  company: "box",
  logoName: "Box",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BoxMonoLogo */.Xb7, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CCustomerAI Predictions has equipped Box\u2019s marketing team with the ability to forecast customer behavior to a degree that was simply unavailable to us before. We\u2019ve been able to explore segmenting our audience based on predictive traits like who is most likely to join us at in-person events or who is more likely to purchase, and this allows us to meet those people where they are in their customer journey.\u201D",
  name: "Chris Koehler",
  position: "CMO at Box"
}, {
  company: "vacasa",
  logoName: "Vacasa",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VacasaMonoLogo */.Ciy, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio and Segment enable Vacasa to understand the entire customer journey to more effectively deliver personalized messages to guests and remove friction from their vacation experience.\u201D",
  name: "G Scott",
  position: "Director of Marketing Analytics",
  extendedRate: "3x",
  extendedText: "more guest bookings with personalized campaigns",
  extendedLink: "/customers/vacasa/"
}, {
  company: "fox",
  logoName: "Fox",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FoxMonoLogo */.xrs, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "When you use any of our mobile apps, you should be greeted like an old friend. When we deliver an ad to you, it should be relevant. When we suggest content to you, it should be in line with your tastes. This is all thanks to Segment.",
  name: "Daryl Bowden",
  position: "Executive Vice President, Technology Platforms at FOX Corporation",
  extendedRate: "376",
  extendedRateSymbol: "",
  extendedText: "more visitors to FOX Sports \u201CFor You\u201D app"
}, {
  company: "bonobos",
  logoName: "Bonobos",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BonobosMonoLogo */.Trx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAs our business grows, it has become increasingly important to understand how online spend influences offline behavior, which Facebook and Segment have made possible.\u201C",
  name: "Micky Onvural",
  position: "Co-President",
  extendedRate: "3x",
  extendedText: "increase in offline purchases versus control group",
  extendedLink: "/customers/bonobos/"
}, {
  company: "ibm",
  logoName: "IBM",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* IbmMonoLogo */.cEr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith real-time integrated data flows from Segment, we can truly understand what people are doing with our platform.\u201D",
  name: "Nic Sauriol",
  avatar: "",
  position: "Software Development Leader",
  extendedRate: "70",
  extendedRateSymbol: "%",
  extendedText: "increase in revenue following a three-month customer messaging pilot program",
  extendedLink: "/customers/ibm/"
}, {
  company: "rugs-com",
  logoName: "Rugs.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RugsComMonoLogo */.ONK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment\u2019s first-party audience targeting capabilities directly improved our return on ad spend. With better performing Google and Facebook campaigns...we were able to reinvest part of our optimized ad budgets into other high growth initiatives.\u201D",
  name: "Grayson Bagwell",
  position: "Director of Business Development and E-Commerce",
  extendedRate: "400",
  extendedRateSymbol: "%",
  extendedText: "YoY revenue growth",
  extendedLink: "/customers/rugs-dot-com/"
}, {
  company: "digital-ocean",
  logoName: "DigitalOcean",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DigitalOceanMonoLogo */.G7L, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment allows us to be more precise with how we dynamically suppress or target users in ad campaigns based on actual product usage.\u201D",
  name: "Sam Coren",
  position: "Senior Demand Generation Manager",
  extendedRate: "33",
  extendedRateSymbol: "%",
  extendedText: "improvement in cost per conversion",
  extendedLink: "/customers/digital-ocean/"
}, {
  company: "pager-duty",
  logoName: "PagerDuty",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* PagerDutyMonoLogo */.e90, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUsing Pendo and Segment to create this onboarding flow, rather than building it out as part of the core PagerDuty product, saves valuable time for engineering.\u201D",
  name: "Hailey Hickman",
  position: "Program Manager",
  extendedRate: "178",
  extendedRateSymbol: "%",
  extendedText: "increase in mobile app downloads",
  extendedLink: "/customers/pagerduty/"
}, {
  company: "drift",
  logoName: "Drift",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DriftMonoLogo */.BPv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe're using Twilio Engage as our new-age CRM. We identify which prospects are most likely to convert by aggregating individual user intent signals for each account...\u201D",
  name: "Guillaume Cabane",
  position: "Former VP of Growth",
  extendedRateSymbol: "%",
  extendedRate: "150",
  extendedText: "increase in positive conversations in 2 months",
  extendedLink: "/customers/drift/"
}, {
  company: "dominos",
  logoName: "Domino's",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DominosMonoLogo */.ooH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Domino\u2019s turned to Twilio Segment to create a universal view of the customer, better visibility of ad campaign effectiveness, and create hyper personalized audiences with Twilio Engage to increase ROAS, revenue and incremental orders across all paid and owned e-commerce channels.",
  name: "",
  position: "Domino's",
  extendedRateSymbol: "%",
  extendedRate: "65",
  extendedText: "decrease in customer acquisition cost",
  extendedLink: "/customers/dominos/"
}, {
  company: "ab-in-bev",
  logoName: "ABInBev",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AbInBevMonoLogo */.gud, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201COur products are vital to our customers\u2019 businesses, and through BEES we\u2019ve empowered them to order the products their consumers love anytime, anywhere. Couple this with real time messaging about when their products will arrive, and what changes have taken place in the process, if any, has deepened our relationship with our customers immensely.\u201D",
  name: "Jason Lambert",
  position: "SVP Product at BEES",
  extendedRateSymbol: "",
  extendedRate: "$2",
  extendedText: "businesses buzzing through a next generation B2B platform with Twilio Segment",
  extendedLink: "/customers/ab-inbev/"
}, {
  company: "crypto-com",
  logoName: "Crypto.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CryptoComMonoLogo */.K9k, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe knew from day one that Twilio\u2019s solutions were the most qualified because our developers had first-hand experience, knowledge, and success working with them in the past.\u201D",
  name: "Matthew Chan",
  position: "Chief Technology Officer",
  extendedRateSymbol: "%",
  extendedRate: "900",
  extendedText: "forecasted increase in user-base by 2023",
  extendedLink: "/customers/crypto/"
}, {
  company: "earnest",
  logoName: "Earnest",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* EarnestMonoLogo */.Iei, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment provided Earnest with a single user identity and consistent, granular customer data that the team needed to create the advanced, customized metrics to scale the affiliate program.\u201D",
  name: "Goutham Valeti",
  position: "Head of Analytics",
  extendedRate: "10x",
  extendedText: "loan volume growth and saved borrowers well over $100M",
  extendedLink: "/customers/earnest/"
}, {
  company: "clear-score",
  logoName: "ClearScore",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ClearScoreMonoLogo */.Ojb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe cost of a Segment investment completely beat our in-house options out of the water. It was a no-brainer in terms of cost.\u201D",
  name: "Klaus Thorup",
  avatar: "",
  position: "Chief Technology Officer",
  extendedRate: "3x",
  extendedText: "cost savings with Twilio Segment instead of building in-house",
  extendedLink: "/customers/clearscore/"
}, {
  company: "toggle",
  logoName: "Toggle",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ToggleMonoLogo */.nSO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWhat we have in Segment is a platform for serendipity. We\u2019re able to react to many scenarios, innovate quickly, scale resources, and bolster a culture of digital transformation.\u201D",
  name: "Todd Wright",
  position: "Sr. Technologist",
  extendedRateSymbol: "%",
  extendedRate: "64",
  extendedText: "decrease in cost per acquisition",
  extendedLink: "/customers/toggle/"
}, {
  company: "stylepit",
  logoName: "Stylepit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* StylepitMonoLogo */.$K_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment proved to us that our first-party data was more valuable than any third-party data\u2014even third-party tracking cookies\u2014could provide.\"",
  name: "Martin Brummerstedt",
  position: "Data Scientist & Digital Project Manager",
  extendedRate: "1.7x",
  extendedText: "increase in ROAS",
  extendedLink: "/customers/stylepit/"
}, {
  company: "tradesy",
  logoName: "Tradesy",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradesyMonoLogo */.qKx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe played around and built a couple of prototypes for our own data pipeline, but we quickly realized that it would take three engineers six months to stabilize a platform, and even then it would not be as feature-rich as Segment.\u201D",
  name: "Geoff Apps",
  position: "CTO at Tradesy",
  extendedRate: "6",
  extendedText: "months saved in engineering time",
  extendedLink: "/customers/tradesy/"
}, {
  company: "frame-io",
  logoName: "FrameIo",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FrameIoMonoLogo */.QzL, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CFrame.io needed a definitive 'single source of truth' where they could unify diverse data sources that would provide the full picture of their customers and Twilio Segment provided that.\u201D",
  name: "Kyle Gesuelli",
  position: "Head of Growth",
  extendedRateSymbol: "%",
  extendedRate: 80,
  extendedText: "reduction in the handle time on support tickets",
  extendedLink: "/customers/frameio/"
}, {
  company: "retool",
  logoName: "Retool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RetoolMonoLogo */.U8Y, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAfter we looked at the costs of building the basic infrastructure and the support required, Twilio Segment became a no-brainer and we upgraded from their Startup Program.\u201D",
  name: "Jane Kelly",
  position: "Head of Growth",
  extendedRateSymbol: "",
  extendedRate: "1000+",
  extendedText: "Retool saved over 1,000 engineering hours by using Twilio Segment",
  extendedLink: "/customers/retool/"
}, {
  company: "meredith",
  logoName: "Meredith",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MeredithMonoLogo */.eqZ, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has enabled us to streamline the data capture process while maintaining flexibility to customize per brand as needed.\u201C",
  name: "Grace Preyapongpisan",
  position: "Vice President, Business Intelligence",
  extendedRate: 36,
  extendedText: "brands centralized on the same data analytics infrastructure",
  extendedLink: "/customers/meredith/"
}, {
  company: "candu",
  logoName: "Candu",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CanduMonoLogo */.IBI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe developer experience with Segment was super easy. Docs were robust enough for us to follow and build an integration within a day.\u201C",
  name: "Michele Riccardo Esposito",
  position: "Chief Technology Officer"
}, {
  company: "looker",
  logoName: "Looker",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LookerMonoLogo */.lpP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CHaving a consistent pipeline of clean and standardized first-party data from Segment is an extremely valuable and core data set for our customers\u2019 success.\u201C",
  name: "Keenan Rice",
  position: "VP Strategic Alliances"
}, {
  company: "trustpilot",
  logoName: "Trustpilot",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TrustpilotMonoLogo */.OPh, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment\u2019s Privacy Portal gives us the confidence to align our event data streams with our company\u2019s data privacy and governance standards. With real-time visibility across our event streams, we are able to proactively respect our customers\u2019 privacy.\u201C",
  name: "Rudy Martin",
  position: "Chief Information Security Office"
}, {
  company: "adviso",
  logoName: "Adviso",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdvisoMonoLogo */.HXI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWorking with Segment allows us to better serve our clients by delivering deeper insights, more quickly. Segment reduces time spent building data pipelines and allows us to provide access to reliable, clean, and actionable data to our customers.\u201C",
  name: "Louis-Philippe Mathieu",
  position: "Data Scientist"
}, {
  company: "prolific-interactive",
  logoName: "ProlificInteractive",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ProlificInteractiveMonoLogo */.BDm, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment understands the value of having their end-users be experts on the platform, and that remains a top priority for them. Instead of simply doing it for you, they take the time to guide you to a deeper level of understanding of the nuances of their platform.\u201C",
  name: "David Reyneke",
  position: "Sr. Growth Manager"
}, {
  company: "y-combinator",
  logoName: "YCombinator",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* YCombinatorMonoLogo */.ah_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment helps businesses set up analytics the way it was meant to be \u2014 quantifying product-market fit, understanding customers, and trying new tools \u2014 all without redundant or time-consuming work.\u201C",
  name: "Gustaf Alstr\xF6mer",
  position: "Partner at Y Combinator"
}, {
  company: "flowers-1800",
  logoName: "Flowers1800",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* Flowers1800MonoLogo */.QZv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Twilio Engage, we are able to collect, unify and connect customer data in real time and build meaningful relationships at every touchpoint of the customer journey. We\u2019re accelerating our digital business and data infrastructure by nearly a decade, and by doing so, delighting our customers.\u201C",
  name: "Amit Shah",
  position: "President"
}, {
  company: "shutterstock",
  logoName: "Shutterstock",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ShutterstockMonoLogo */.IcO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Shutterstock partnered with Segment to unlock the personalization power for their email campaigns. Segment\u2019s expertise accelerated the digital media marketplace\u2019s customer experience with contextually relevant messaging and a 30% lift in click rates."
}, {
  company: "typeform",
  logoName: "Typeform",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TypeformMonoLogo */.wJ3, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUntil we started standardizing our data, people didn\u2019t realize how messy it had become. With Protocols, we can be confident that data quality issues don\u2019t happen anymore.\u201D",
  name: "Colin Furlong",
  position: "Data Operations & Tracking",
  extendedRateSymbol: "%",
  extendedRate: 75,
  extendedText: "Reduction in duplicate or extraneous tracked events",
  extendedLink: "/customers/typeform/"
}, {
  company: "creative-market",
  logoName: "CreativeMarket",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CreativeMarketMonoLogo */.w1t, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CProtocols provides the context my teams need to effectively use our customer data in campaigns and analyses.\u201D",
  name: "Akshay Singh",
  position: "Former extended & Product Analytst",
  extendedRateSymbol: "%",
  extendedRate: 93,
  extendedText: "Reduction in time to detect data issues",
  extendedLink: "/customers/creative-market/"
}, {
  company: "allergan",
  logoName: "Allergan",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AllerganMonoLogo */.ubl, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe lean heavily on Segment today to identify our consumers and their profile traits, what makes them them, and what kind of journey they are on.\u201D",
  name: "Christine Li",
  position: "Director of Marketing Technology",
  extendedRate: "400M+",
  extendedText: "In sales driven in 2021 YTD by direct-to-consumer",
  extendedLink: "/customers/allergan/"
}, {
  company: "amboss",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AmbossMonoLogo */.D9K, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "Amboss",
  text: "\u201C[...]Twilio Segment has been game-changing, helping us to centralize our customer data far more quickly, efficiently and cost effectively than we could have imagined.\u201D",
  name: "Elmar Weber",
  position: "Chief Technical Officer",
  extendedText: "Reduced time to insights from days to minutes",
  extendedLink: "/customers/amboss/"
}, {
  company: "chopra",
  logoName: "Chopra",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ChopraMonoLogo */.aIE, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is significantly cheaper than having a full data team[...]and allowed us to see what our customers are actually doing.\u201D",
  name: "Josh Wexler",
  position: "Chief Product Officer",
  extendedText: "Maximized resources resulting in the building of data-driven products",
  extendedLink: "/customers/chopra/"
}, {
  company: "ritual",
  logoName: "Ritual",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RitualMonoLogo */.qWP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe use Segment as our CDP and the biggest thing it\u2019s given us is flexibility[...]to define what the ideal experience is for our customers.\u201D",
  name: "Laura Brodie",
  position: "Director of Customer Lifecycle and Growth",
  extendedText: "More agile audience development and increased LTV over time",
  extendedLink: "/customers/ritual/"
}, {
  company: "theVintageBar",
  logoName: "TheVintageBar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheVintageBarMonoLogo */.u$x, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has empowered our company to make decisions smarter and faster to give our customers the best experience possible. With constant experimentation, sophisticated customer data models, and journey mapping, we can deliver personalization at scale and across all channels.\u201D",
  name: "Nikolaj Toxv\xE6rd",
  position: "Chief Marketing Officer",
  extendedRate: "6x",
  extendedText: "inventory growth in 6 months with optimized experiences",
  extendedLink: "/customers/the-vintage-bar/"
}, {
  company: "good-eggs",
  logoName: "GoodEggs",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* GoodeggsMonoLogo */.nCX, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment has proven not only to be simple, fast, and reliable \u2014 but also an accelerant. Engineering can now focus on features and use cases, rather than infrastructure to get our events from the edge to downstream systems.\"",
  name: "Bob Zoller",
  position: "Founding Engineer",
  extendedRate: "0 Hours",
  extendedText: "engineering time spend managing data pipelines",
  extendedLink: "/customers/goodeggs/"
}, {
  company: "halp",
  logoName: "Halp",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* HalpMonoLogo */.JRr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Using Segment, you save a combination of time and money.\"",
  name: "Fletcher Richman",
  position: "CEO and Co-Founder",
  extendedRate: "4x",
  extendedText: "improvement in the number of activated sign-ups",
  extendedLink: "/customers/halp/"
}, {
  company: "craft-jack",
  logoName: "CraftJack",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CraftJackMonoLogo */.Vsb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"With Twilio Engage, we are able to do the work of three or four different tools, all in one centralized platform. We are able to bring transactional conversation and personalized marketing messages all into Twilio Engage for greater efficiency.\"",
  name: "Jordan Dietch",
  position: "VP of Product Management, CraftJack",
  extendedText: "31% increase in new user signups YoY and 80% increase in engineering implementation efficiency",
  extendedLink: "/customers/craftjack/"
}, {
  company: "mongodb",
  logoName: "mongodb",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSince implementing Segment we have seen a significant increase in revenue which we attribute to the improved targeting and personalization of our communications.\u201D"
}, {
  company: "sanofi",
  logoName: "sanofi",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SanofiMonoLogo */.he8, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe process before Segment was much more cumbersome and difficult to explain to marketers. Now, Segment allows us to compile data all in one place, forming a Golden Profile, and allows for other teams to easily utilize and activate data.\u201D"
}, {
  company: "the-motley-fool",
  logoName: "the-motley-fool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheMotleyFoolMonoLogo */.DeK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is much more of a self-service platform. Whereas before we were limited in how we could message or target prospects and members, we can now build and activate audiences almost immediately.\u201D"
}, {
  company: "univision",
  logoName: "univision",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* UnivisionMonoLogo */.KML, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CRegardless of scale, Segment provides you the tools and platform to move quickly and efficiently. We couldn\u2019t\n    have done this any other way.\u201C"
}, {
  company: "crossfit",
  logoName: "crossfit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CrossFitMonoLogo */.DvB, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CNow, our data and teams are cohesive and connected, we can make data driven decisions and reach our customers\n    effectively.\u201C"
}, {
  company: "arduino",
  logoName: "arduino",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ArduinoMonoLogo */.Yt2, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CA big benefit of Segment is being able to activate our first-party data all in one platform. Our previous\n    tool required more manual effort, and therefore limited our marketing communication options\u201C"
}, {
  company: "fender",
  logoName: "Fender",
  text: "To increase adoption and retention rates, Fender also uses tools from Twilio Segment to optimize the customer\n    sales funnel by streamlining the onboarding process.",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FenderMonoLogo */.bf1, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  name: "",
  position: "",
  extendedRate: "29%",
  extendedText: "reduction in customer churn rate for paid app",
  extendedLink: "/customers/fender"
}, {
  company: "trademe",
  logoName: "TradeMe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradeMeMonoLogo */.KH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe marketing team has been making very good use of CustomerAI Predictions, and we are keen on continuing to use it to drive campaigns across digital channels.\u201D"
}, {
  company: "camping-world",
  logoName: "CampingWorld",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CampingWorldMonoLogo */.H1r, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Engage allows Camping World to track events like \u2018RV model viewed\u2019 and \u2018RV added to favorites list\u2019 to create profiles, then utilize this information to craft specific omni-channel messages.\u201D"
}, {
  company: "adevinta",
  logoName: "Adevinta",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdevintaMonoLogo */.fGv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "With Segment at its core, Adevinta will enable cross-organizational collaboration through standardized data leading to relevant, personalized customer touch points across all its channels."
}, {
  company: "vervoe",
  logoName: "Vervoe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VervoeMonoLogo */.VhY, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe rely on Segment pretty heavily to feed all of the platforms to understand where the breakdowns are within the customer journey.\u201D"
}, {
  company: "tillster",
  logoName: "Tillster",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TillsterMonoLogo */.Tys, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Segment, we are able to use more personalization and intelligent targeting\u201C"
}, {
  company: "smartcar",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBuilding a user-friendly API isn\u2019t always easy\u2014especially if you want to appeal to your users and their users. Thanks to Twilio Segment, we can focus on both areas in one go, and give our team the chance to measure and evaluate the things they feel are most important.\u201D"
  }),
  name: "Sanketh Katta",
  position: "CTO and co-founder, Smartcar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SmartcarMonoLogo */.DXF, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SmartcarLogo */.GQ7, {}),
  logoName: "Smartcar",
  extendedRate: "22%",
  extendedText: "improvement in developer application conversions",
  extendedLink: "/customers/smartcar/"
}, {
  company: "lens-online",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CWhile our previous tech stack, including a CRM, SAP, Zendesk, etc. supported our early growth, it wasn't enough for our future ambitions. We needed to not just understand but anticipate our customer's needs. This realization led us to Twilio Segment, moving beyond traditional CRMs to a 360-degree view of customers, integrating every customer interaction and preference with a customer data platform.\u201D"
  }),
  name: "Pascal",
  position: "CMO & CDO, LensOnline",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LensOnlineMonoLogo */.FRf, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* LensOnlineLogo */.vmS, {}),
  logoName: "Fender",
  extendedRate: "15%",
  extendedText: "reduction in marketing spend",
  extendedLink: "/customers/lens-online/"
}, {
  company: "veronica-beard",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBased on our research, we know that omnichannel customers are our most valuable customers. Because of this, we build Twilio Engage Audiences of our omnichannel customers and top customers in lifetime revenue, to use as the basis for lookalike audiences in Facebook Ads.\u201D"
  }),
  name: "Maxime Lagresle",
  position: "Ecommerce Analytics Manager",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VeronicaBeardMonoLogo */.i_T, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "VeronicaBeard",
  extendedRate: "20% ",
  extendedText: "Reduction in customer acquisition costs (CAC) from Facebook Ads",
  extendedLink: "/customers/veronica-beard/"
}];
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/Testimonial.tsx







var TestimonialTemplate = function TestimonialTemplate(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "base" : _ref$variant,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? variant === "extended" ? "460px" : "auto" : _ref$height,
      overrides = _ref.overrides,
      company = _ref.company,
      color = _ref.color,
      logo = _ref.logo,
      text = _ref.text,
      avatar = _ref.avatar,
      name = _ref.name,
      position = _ref.position,
      extendedRate = _ref.extendedRate,
      extendedRateSymbol = _ref.extendedRateSymbol,
      extendedText = _ref.extendedText,
      extendedLink = _ref.extendedLink;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var companyData = data.find(function (item) {
    return item.company === company;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* default */.ZP, {
    variant: variant,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
      color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
      overrides: overrides,
      height: height,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
          children: (companyData === null || companyData === void 0 ? void 0 : companyData.logo) || logo
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
          children: text || (companyData === null || companyData === void 0 ? void 0 : companyData.text)
        })]
      }), (name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseAuthorSlot */.hC, {
        children: [(avatar || (companyData === null || companyData === void 0 ? void 0 : companyData.avatar)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorAvatar */.DV, {
          alt: "Portrait of" + name,
          src: avatar || String(companyData === null || companyData === void 0 ? void 0 : companyData.avatar)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
            children: name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
            children: position || (companyData === null || companyData === void 0 ? void 0 : companyData.position)
          })]
        })]
      })]
    }), variant === "extended" && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Extended */.jW, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedTextSlot */.VJ, {
        children: [(extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedHeader */.S2, {
          color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
          children: [extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate), (extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedHeaderSup */.Jk, {
            children: extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedText */.wN, {
          children: extendedText || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedText)
        })]
      }), (extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButtonSlot */.Wi, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedStoryLink */.c9, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButton */.Di, {
            colored: Boolean(color),
            href: (0,getAbsoluteUrl/* default */.Z)(extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink) || "", pageConfig),
            text: "Read their story"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Testimonial_Testimonial = (TestimonialTemplate);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 37012:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security",
      function () {
        return __webpack_require__(2248);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17731:
/***/ (function(module) {

module.exports = "/_next/static/images/OgSecurity-b5b17d4f64260275feecee885fe0296f.png";

/***/ }),

/***/ 34717:
/***/ (function(module) {

module.exports = "/_next/static/images/AicpaSocBadge@2x-0e214cd1ae852ca82ef2cd8dbb873f47.png";

/***/ }),

/***/ 91481:
/***/ (function(module) {

module.exports = "/_next/static/images/Iso27001@2x-80061c433836fded9fb70f20ef5bbe71.png";

/***/ }),

/***/ 80548:
/***/ (function(module) {

module.exports = "/_next/static/images/Iso27017@2x-c41c4caf7e0dec919409188f1d3ce341.png";

/***/ }),

/***/ 51723:
/***/ (function(module) {

module.exports = "/_next/static/images/Iso27018@2x-f0a13d0087f6e07a57bec58532803fcf.png";

/***/ }),

/***/ 49946:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-lg@2x-f1c40067363e3746d8d1a70af39c888e.png";

/***/ }),

/***/ 56383:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs@2x-fc26f6f23d1c61bf0392ac47e5c0c646.png";

/***/ }),

/***/ 25484:
/***/ (function(module) {

module.exports = "/_next/static/images/InternalSecurity@2x-3772707ab15f342bed799ddf29231ea3.png";

/***/ }),

/***/ 14941:
/***/ (function(module) {

module.exports = "/_next/static/images/AicpaSocBadge-8501375fcfa916aa0d256153690674f6.webp";

/***/ }),

/***/ 91083:
/***/ (function(module) {

module.exports = "/_next/static/images/AicpaSocBadge@2x-8501375fcfa916aa0d256153690674f6.webp";

/***/ }),

/***/ 53965:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-lg-b2d94a612faae085145e25da11898f61.webp";

/***/ }),

/***/ 20999:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-lg@2x-7a99f86afbcd8e9ae10ad2a52b5b42a5.webp";

/***/ }),

/***/ 17595:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-lg@3x-b7e06ecc1a2a7007427ba7a95e75684b.webp";

/***/ }),

/***/ 28657:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs-66a79d4f02f723ade060dbfd6259ee60.webp";

/***/ }),

/***/ 31814:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs@2x-c775b5d214e3a05a1bdf85cf640962ea.webp";

/***/ }),

/***/ 25510:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs@3x-0d1652174b6ded4e25a279980ea9cd9d.webp";

/***/ }),

/***/ 7085:
/***/ (function(module) {

module.exports = "/_next/static/images/InternalSecurity-9428ed5e944f54c057c89abc3791e4e1.webp";

/***/ }),

/***/ 95084:
/***/ (function(module) {

module.exports = "/_next/static/images/InternalSecurity@2x-8c7119db5c767bef74855998fb63f513.webp";

/***/ }),

/***/ 97710:
/***/ (function(module) {

module.exports = "/_next/static/images/InternalSecurity@3x-d14ce5d9a02c48e7678804d75cb00218.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,442,7079,4881,1385,3379,9550,814,9774,2888,179], function() { return __webpack_exec__(37012); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);